import React from 'react';
import arriveIcon from '@/assets/arrive-icon.png';
import followIcon from '@/assets/follow-icon.png';
import orderIcon from '@/assets/order-icon.png';
import subscribeIcon from '@/assets/subscribe-icon.png';
import styles from './index.module.less';

export default function OperationBoard ({ detailData = {} })  {

  return (
    <div className={styles.operationBoardBox}>
      <div className={styles.operationBoard}>
        <div className={styles.cardBox}>
          <img className={styles.cardImg} src={followIcon}/>
          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>跟进次数</div>
            <div className={styles.cardContentA}>{ (detailData as any)?.followNum }</div>
          </div>
        </div>
        <div className={styles.cardBox}>
          <img className={styles.cardImg} src={subscribeIcon}/>
          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>预约次数</div>
            <div className={styles.cardContentB}>{ (detailData as any)?.appointmentNum }</div>
          </div>
        </div>
        <div className={styles.cardBox}>
          <img className={styles.cardImg} src={arriveIcon}/>
          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>到店次数</div>
            <div className={styles.cardContentC}>{ (detailData as any)?.arrivalNum }</div>
          </div>
        </div>
        <div className={styles.cardBox}>
          <img className={styles.cardImg} src={orderIcon}/>
          <div className={styles.cardContent}>
            <div className={styles.cardTitle}>订单金额</div>
            <div className={styles.cardContentD}>{ (detailData as any)?.amount }</div>
          </div>
        </div>
      </div>
    </div>
  )
}